import { gql } from '@common/hooks';
import { DetailItemAttachments } from '@onboarding/graphql/fragments';
import { FullValidationErrorFragment } from '@common/graphql/fragments';

const CreateLicenseMutation = gql`
  mutation CreateLicenseMutation(
    $input: CreateLicenseInput!
    $worksProfileId: ID!
    $worksListItemId: ID!
    $files: [FileUploadInput!]!
  ) {
    createLicense(
      input: $input
      worksProfileId: $worksProfileId
      worksListItemId: $worksListItemId
      files: $files
    ) {
      license {
        id
        detailItemAttachments {
          ...DetailItemAttachments
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
  ${DetailItemAttachments}
`;

const UpdateLicenseMutation = gql`
  mutation UpdateLicenseMutation(
    $id: ID!
    $input: UpdateLicenseInput!
    $files: [FileUploadInput!]!
  ) {
    updateLicense(id: $id, input: $input, files: $files) {
      license {
        id
        detailItemAttachments {
          ...DetailItemAttachments
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
  ${DetailItemAttachments}
`;

export { CreateLicenseMutation, UpdateLicenseMutation };
